import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Box, Select, Spacer } from "@flexisaf/flexibull2";
import PropTypes from 'prop-types';

import { SchemaContext } from '../container'

const CustomData = props => {
  const { disabledFields, errorFields, fieldValue, updateFieldValue } = useContext(SchemaContext)
  const [data, setData] = useState({})

  /* 
   Load data from url if provided
   data will be in the format of
   { key1: [value, value2, ...], key2: [value, value2, ...], key3: [value, value2, ...] }
  */
  useEffect(() => {
    if(props.source) {
      fetch(props.source)
        .then(res => res.json())
        .then(res => setData(res))
        .catch(err => console.log(err))
    }
  }, [props.source])

  const updateValue = (key, val) => {
    if (disabledFields.includes(props.keyField)) return;
    const newVal = [...(fieldValue?.[props.keyField] || [])];
    newVal[key] = val;
    if (key === 0) newVal[1] = null;

    updateFieldValue(props.keyField, newVal)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <label style={{ fontWeight: "700", fontSize: "0.9em", textTransform: "uppercase" }}>
                {props?.props?.label} {props.required && <span style={{ color: 'red' }}>*</span>}
      </label>
      <Spacer space="8px" />
      <Box pad="-22px 0px 0px 0px">
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
          <Select
            style={{ width: '49%' }}
            placeholder="Select"
            options={Object.keys(data).map(s => ({ label: s, value: s }))}
            value={!fieldValue?.[props.keyField]?.[0] ? null : { label: fieldValue?.[props.keyField]?.[0], value: fieldValue?.[props.keyField]?.[0] }}
            onChange={({ value }) => updateValue(0, value)}
            label={props.primaryLabel}
            required={props?.required}
            error={!fieldValue?.[props.keyField]?.[0] && errorFields[props.keyField]}
            disable={disabledFields.includes(props.keyField)}
          />
          <Select
            style={{ width: '49%' }}
            placeholder="Select"
            options={
              !fieldValue?.[props.keyField]?.[0]
                ? []
                : data[fieldValue?.[props.keyField]?.[0]]?.sort()?.map(s => ({ label: s, value: s }))
            }
            value={!fieldValue?.[props.keyField]?.[1] ? null : { label: fieldValue?.[props.keyField]?.[1], value: fieldValue?.[props.keyField]?.[1] }}
            onChange={({ value }) => updateValue(1, value)}
            label={props.secondaryLabel}
            required={props?.required}
            error={!fieldValue?.[props.keyField]?.[1] && errorFields[props.keyField]}
            disable={disabledFields.includes(props.keyField)}
          />
        </div>
      </Box>
    </div>
  )
}

CustomData.defaultProps = {
  label: null,
  placeholder: 'Select option',
  helper: null,
  type: "text",
  required: false,
  primaryLabel: '',
  secondaryLabel: '',
  rules: {
    validation: null,
    before: null
  }
};

CustomData.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  helper: PropTypes.string,
  type: PropTypes.string,
  rules: PropTypes.any,
  primaryLabel: PropTypes.string,
  secondaryLabel: PropTypes.string,
  options: PropTypes.any.isRequired,
  source: PropTypes.string.isRequired
};

export default CustomData;